import {RouteObject} from "react-router-dom";

export default [
    {
        index: true,
        lazy: () => import("modules/leaderboard/pages/leaderboard"),
    },
] as RouteObject[];
